module.exports = __webpack_public_path__ + "media/images/official/special_hopper_toyoda_profile-a492ff231cc6205d65dcbab8130d4012.png";